<template>
  <div class="index-room">
    <router-link :to="{name: 'CreateRoom'}"><button type="button" name="button" class="btn btn-primary">ルーム作成</button></router-link>
    <div class="card">
      <div class="card-header">
        ルーム一覧
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item" v-for="room in reverseRooms" :key="room.id"><router-link :to="{name: 'JoinRoom', params: {room_id: room.id}}">{{ room.name }}</router-link></li>
      </ul>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'index-room',
  components: {

  },
  data() {
    return {
      rooms: [],
      reverseRooms: []
    }
  },
  created(){
    const db = firebase.firestore();
    const vue = this;

    const nowDate = new Date();
    const startDate = new Date(nowDate - 86300000);

    db.collection('rooms').orderBy('created').startAt(startDate).get().then((es) => {
      es.forEach((doc) => {
          vue.rooms.push({name: doc.data().name, id: doc.id});
        });

        vue.reverseRooms = vue.rooms.reverse();
    });
  }
}
</script>
<style scoped>
</style>
